'use client';

import Link from 'next/link';
import { useAuth } from '@/lib/auth-context';

export function SubstrateNavLink() {
  const { role, isLoading } = useAuth();

  if (isLoading || (role !== 'admin' && role !== 'trusted' && role !== 'delegate')) {
    return null;
  }

  return (
    <Link
      href="/substrate"
      className="ml-3 text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-zinc-100 px-3 py-2 text-sm font-medium"
    >
      Substrate
    </Link>
  );
}
